<p
  [ngClass]="[variant, 'mb-0']"
  *ngIf="html"
  [innerHtml]="sanitizedHtmlService.sanitizedHtml(html)"></p>

<p [ngClass]="[variant, 'mb-0']" *ngIf="!html">
  <ng-content></ng-content>
</p>
